<template >
  <router-view></router-view>
</template>

<script>
import Api from './Api'

export default {
  name: 'App',
   
  created () {
    this.$store.dispatch('auth/refreshLoginData');
    this.$store.dispatch('user/refreshSetup');
    this.addRequestHeaderToApiReq();
    
  },
  methods:{

    addRequestHeaderToApiReq(){
      Api.interceptors.request.use((config) =>{
        const token =this.$store.getters['auth/accessToken'];
        console.log(token);
          if ( token != null ) {
            config.headers.Authorization = 'Bearer '+token;
          }
          return config;
        }, (err)=> {
          return Promise.reject(err);
        });
    }
  }
}
</script>
